import React, { useMemo } from 'react';
import { Col, Row } from '../row';
import { Text } from '../typography/Text';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';
import { mcNavigateNext, mcNavigatePrev } from '@mc/react-ui-icons';
import classNames from 'classnames';
import { Classes, VF } from '../index';
import { Form } from 'react-final-form';
import { formatNumber } from '@mc/react-format';
type Props = {
  page: number;
  pageSize: number;
  totalItems: number;
  setPage: (page: number) => void;
  className?: string;
  hasFooter?: boolean;
};
export const Pagination: React.FC<Props> = ({
  page,
  pageSize,
  totalItems,
  setPage,
  className,
  hasFooter,
}) => {
  const noData = totalItems === 0;
  const totalPages = Math.ceil(totalItems / pageSize);
  let firstItemIndex = (page - 1) * pageSize + 1;
  let lastItemIndex = Math.min(page * pageSize, totalItems);
  const prevPage = () => {
    setPage(page - 1);
  };
  const nextPage = () => {
    setPage(page + 1);
  };
  const intialData = useMemo(() => ({ pageInput: page }), [page]);
  const PAGE_ERROR = 'Neplatná stránka';
  return (
    <div
      className={classNames(Classes.PAGINATION, className, {
        [Classes.PAGINATION_SHADOW]: !hasFooter,
        [Classes.PAGINATION_NO_DATA]: noData,
      })}
    >
      <Row>
        {!noData && (
          <Col xs={'auto'} className={'d-flex align-items-center'}>
            <Text intent={'secondary'}>Stránka</Text>
            <Form<{ pageInput: number }>
              validate={(data) => {
                const errors = {};
                if (!data.pageInput) {
                  // @ts-ignore
                  errors.page = PAGE_ERROR;
                }
                if (data.pageInput < 1) {
                  // @ts-ignore
                  errors.page = PAGE_ERROR;
                }
                if (data.pageInput > totalPages) {
                  // @ts-ignore
                  errors.page = PAGE_ERROR;
                }
                return errors;
              }}
              initialValues={intialData}
              onSubmit={(data) => {
                setPage(data.pageInput);
              }}
            >
              {({ handleSubmit }) => {
                return (
                  <div className={Classes.PAGINATION_BUTTON_CONTAINER}>
                    <Button
                      dataTest={'prev-page'}
                      noPadding
                      className={Classes.PAGINATION_PAGE_BUTTON}
                      disabled={page === 1}
                      icon={<Icon icon={mcNavigatePrev} />}
                      onClick={prevPage}
                      style={'link'}
                    />
                    <VF.Number
                      inlineValidation
                      className={Classes.PAGINATION_PAGE_INPUT}
                      onBlur={handleSubmit}
                      onlyPositive
                      label={false}
                      name={'pageInput'}
                    />
                    <Button
                      dataTest={'next-page'}
                      className={Classes.PAGINATION_PAGE_BUTTON}
                      disabled={page >= totalPages}
                      icon={<Icon icon={mcNavigateNext} />}
                      onClick={nextPage}
                      style={'link'}
                    />
                  </div>
                );
              }}
            </Form>

            <Text intent={'secondary'}>{` z ${formatNumber(
              totalPages || 0
            )}`}</Text>
          </Col>
        )}
        <Col className={Classes.PAGINATION_INFO}>
          {!noData && (
            <Text intent={'secondary'}>{`${formatNumber(
              firstItemIndex || 0
            )}-${formatNumber(lastItemIndex || 0)} z ${formatNumber(
              totalItems || 0
            )} záznamů`}</Text>
          )}
        </Col>
      </Row>
    </div>
  );
};
